/**
 * GraphQL operations for the InterviewGuides feature.
 *
 * Split by domain:
 *   - fragments              — shared GQL fragments (header / full guide / scorecard)
 *   - guideOperations        — guide & guide-question queries + mutations
 *   - questionBankOperations — global question-bank queries + mutations
 *   - scorecardOperations    — scorecard + transcript queries + mutations
 *
 * Consumers should import named operations from this index (or from the
 * legacy `../operations` re-export which is preserved for back-compat).
 */
export * from "./fragments";
export * from "./guideOperations";
export * from "./questionBankOperations";
export * from "./scorecardOperations";
